"use client";

import { getUserProfile } from "@/services/user";
import { getCookie } from "@/utils";
import * as amplitude from "@amplitude/analytics-browser";
import { useEffect } from "react";

const InitAnalytics = () => {
  useEffect(() => {
    const initAnalytics = async () => {
      const email = getCookie("email");
      const token = getCookie("token");
      const userProfile = await getUserProfile(token);
      const identifyEvent = new amplitude.Identify();
      identifyEvent.set("Email", email ?? "");
      if (userProfile?.user?.platformProfile?.name)
        identifyEvent.set("Name", userProfile.user.platformProfile.name);
      else {
        const name = email?.split("@")[0] ?? "";
        identifyEvent.set("Name", name);
      }

      amplitude.identify(identifyEvent);
      amplitude.init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY!, {
        // logLevel: amplitude.Types.LogLevel.Debug,
      });
    };
    initAnalytics();
  }, []);

  return null;
};

export default InitAnalytics;
